// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__qDGFW","Horizontal":"NavigationItem_Horizontal__33c1J","active":"NavigationItem_active__l563e"};